var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{class:[
    'w-full px-2  py-1 text-center text-xs font-medium leading-5 text-gray-600 md:text-sm ',
  ],staticStyle:{"white-space":"nowrap"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }